import { downloadInternalAuditPlanAttachment } from '../../../api/internalAudit';
import { InternalAuditPlan } from '../../../types/internalAudit';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/SmallGroupPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: InternalAuditPlan;
}

function InternalAuditPlanPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>심사 계획서</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            계획서번호
            <input readOnly value={detail.planNo || ''} />
          </label>
          <label>
            연도
            <input type="number" readOnly value={detail.planYear ?? ''} />
          </label>
          <label>
            구분
            <select value={detail.auditType || 'REGULAR'} disabled>
              <option value="REGULAR">정기</option>
              <option value="SPECIAL">특별</option>
            </select>
          </label>
          <label className="is-span-2">
            제목
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            기간 시작
            <input type="date" readOnly value={detail.periodFrom || ''} />
          </label>
          <label>
            기간 종료
            <input type="date" readOnly value={detail.periodTo || ''} />
          </label>
          <label>
            피심사 부서/프로세스
            <input readOnly value={detail.auditeeDept || ''} />
          </label>
          <label>
            피심사 책임자
            <input readOnly value={detail.auditeeManager || ''} />
          </label>
          <label className="is-span-2">
            심사 기준
            <input readOnly value={detail.criteriaText || ''} />
          </label>
          <label className="is-span-2">
            목적
            <textarea rows={2} readOnly value={detail.purpose || ''} />
          </label>
          <label className="is-span-2">
            범위
            <textarea rows={2} readOnly value={detail.scopeText || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
          <label>
            주심사원
            <input readOnly value={detail.leadAuditorName || '-'} />
          </label>
          <label className="is-span-2">
            심사팀원
            <input readOnly value={detail.auditorNames || '-'} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="edu-plan-card__title" style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadInternalAuditPlanAttachment(
              detail.planId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
  );
}

export default InternalAuditPlanPreviewView;
